import {
  ZENDESK_CUSTOM_FIELD_NAME,
  ZENDESK_ASSIGNEE_ID,
  ZENDESK_GROUP_ID,
  ZENDESK_TICKET_FORM_ID,
  ZENDESK_COLLABORATOR_ID_VALUE,
} from "@avenueops/shared-types";
import UncontrolledInputCreatableSelect from "components/inputs/UncontrolledInputCreatableSelect";
import UncontrolledInputTextarea from "components/inputs/UncontrolledInputTextarea";
import Skeleton from "react-loading-skeleton";
import { trpc } from "utils/trpc";

interface Props {
  zendeskIntegrationId: string;
  fullFieldName: string;
  fieldValue: string;
  fieldError: any;
  onChange: any;
  isFirst: boolean;
  mappingPrefix: string;
}

export default function EnhancedZendeskMappingInput({ zendeskIntegrationId, fullFieldName, fieldValue, fieldError, onChange, isFirst, mappingPrefix }: Props) {
  const { data: enhancedFieldInfo, isLoading } = trpc.integrations.getEnhancedFieldInfo.useQuery(
    {
      integrationId: zendeskIntegrationId,
    },
    {
      enabled: !!zendeskIntegrationId,
    }
  );

  const title = "Data in Avenue";
  let placeholder = "";
  let options: any[] = [];

  if (!isLoading && enhancedFieldInfo) {
    if (fullFieldName === ZENDESK_CUSTOM_FIELD_NAME && enhancedFieldInfo.customFields.length > 0) {
      options = enhancedFieldInfo.customFields.map((customField) => ({ value: `${customField.id}`, label: `${customField.title} (${customField.id})` }));
      placeholder = "Custom Field ID ...";
    } else if (fullFieldName === ZENDESK_GROUP_ID && enhancedFieldInfo.groups.length > 0) {
      options = enhancedFieldInfo.groups.map((group) => ({ value: `${group.id}`, label: `${group.name} (${group.id})` }));
      placeholder = "Group ID ...";
    } else if (fullFieldName === ZENDESK_ASSIGNEE_ID && enhancedFieldInfo.users.length > 0) {
      options = enhancedFieldInfo.users.map((user) => ({ value: `${user.id}`, label: `${user.name} (${user.id})` }));
      placeholder = "Assignee ID ...";
    } else if (fullFieldName === ZENDESK_COLLABORATOR_ID_VALUE && enhancedFieldInfo.users.length > 0) {
      options = enhancedFieldInfo.users.map((user) => ({ value: `${user.id}`, label: `${user.name} (${user.id})` }));
      placeholder = "Collaborator ID ...";
    } else if (fullFieldName === ZENDESK_TICKET_FORM_ID && enhancedFieldInfo.ticketForms.length > 0) {
      options = enhancedFieldInfo.ticketForms.map((ticketForm) => ({ value: `${ticketForm.id}`, label: `${ticketForm.name} (${ticketForm.id})` }));
      placeholder = "Ticket Form ID ...";
    }
  }
  // Fallback to a text area input if we fail to fetch the enhanced field info or there are no options
  return isLoading ? (
    <div className="bg-white rounded border  w-320 p-1 mt-6">
      <Skeleton count={1} className="text-2xl" />
    </div>
  ) : options.length > 0 ? (
    <div className="flex-1">
      <UncontrolledInputCreatableSelect
        title={title}
        disabled={false}
        options={options}
        val={fieldValue}
        onChange={onChange}
        placeholder={placeholder}
        error={fieldError}
      />
    </div>
  ) : (
    <div className="flex-1">
      <UncontrolledInputTextarea
        title={title}
        placeholder="Embed data like this: {{id}}"
        value={fieldValue}
        onChange={onChange}
        error={fieldError}
        className="w-[20rem] min-w-[10rem]"
      />
    </div>
  );
}
